// Fechas de los mensajes de los chats: en la hora de quien mira y siempre en español (sin depender del idioma del navegador)
const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

const aFecha = (valor) => {
  if (valor === null || valor === undefined || valor === '') return null;
  const fecha = new Date(valor);
  return Number.isNaN(fecha.getTime()) ? null : fecha;
};

// Días de calendario entre la fecha y hoy (0 = hoy, 1 = ayer…); redondea por los días de 23 o 25 horas del horario de verano
const diasAntes = (fecha, ahora) => {
  const inicio = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  return Math.round((inicio(ahora) - inicio(fecha)) / (24 * 60 * 60 * 1000));
};

export const mismoDia = (a, b) => {
  const x = aFecha(a);
  const y = aFecha(b);
  return Boolean(x && y) && x.getFullYear() === y.getFullYear() && x.getMonth() === y.getMonth() && x.getDate() === y.getDate();
};

// "9:05 a.m.", "12:43 p.m."
export const horaMensaje = (valor) => {
  const fecha = aFecha(valor);
  if (!fecha) return '';
  const horas = fecha.getHours();
  return `${horas % 12 || 12}:${String(fecha.getMinutes()).padStart(2, '0')} ${horas < 12 ? 'a.m.' : 'p.m.'}`;
};

// Separador de la conversación: "Hoy", "Ayer", el día de la semana en los últimos 6 días ("Viernes") y, si es más viejo,
// la fecha: "9 de octubre" (de este año) o "31 de diciembre de 2025". Un mensaje "del futuro" (reloj del equipo atrasado) es de hoy.
export const etiquetaDia = (valor, ahora = new Date()) => {
  const fecha = aFecha(valor);
  if (!fecha) return '';
  const dias = diasAntes(fecha, ahora);
  if (dias <= 0) return 'Hoy';
  if (dias === 1) return 'Ayer';
  if (dias < 7) return DIAS[fecha.getDay()];
  const dia = `${fecha.getDate()} de ${MESES[fecha.getMonth()]}`;
  return fecha.getFullYear() === ahora.getFullYear() ? dia : `${dia} de ${fecha.getFullYear()}`;
};

// Lista de conversaciones: la hora si el último mensaje es de hoy, "Ayer", el día de la semana, o "9 oct" / "31 dic 2025"
export const fechaEnLista = (valor, ahora = new Date()) => {
  const fecha = aFecha(valor);
  if (!fecha) return '';
  const dias = diasAntes(fecha, ahora);
  if (dias <= 0) return horaMensaje(fecha);
  if (dias === 1) return 'Ayer';
  if (dias < 7) return DIAS[fecha.getDay()];
  const dia = `${fecha.getDate()} ${MESES_CORTOS[fecha.getMonth()]}`;
  return fecha.getFullYear() === ahora.getFullYear() ? dia : `${dia} ${fecha.getFullYear()}`;
};
